import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressBook, faCalendarDays, faClipboard, faFolderOpen } from '@fortawesome/free-regular-svg-icons';
import { faBookMedical, faFileInvoice, faFileMedicalAlt, faHouseMedical, faUserDoctor, faUserInjured } from '@fortawesome/free-solid-svg-icons';

export type Menu = {
  title: string
  activeIcon?: any,
  inactiveIcon?: any,
  children?: Menu[]
  open?: boolean
  route?: string
}

export const frontDeskMenus: Menu[] = [
  {
    title: "Calendar",
    activeIcon: <FontAwesomeIcon icon={faCalendarDays} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faCalendarDays} size={"2x"} color='#ffffff' />,
    route: "/calendar",
  },
  {
    title: "Consultant",
    activeIcon: <FontAwesomeIcon icon={faUserDoctor} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faUserDoctor} size={"2x"} color='#ffffff' />,
    route: "/consultant",
  },
  {
    title: "Patient Directory",
    activeIcon: <FontAwesomeIcon icon={faUserInjured} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faUserInjured} size={"2x"} color='#ffffff' />,
    route: "/patientList",
  },
  {
    title: "Billing",
    activeIcon: <FontAwesomeIcon icon={faFileInvoice} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faFileInvoice} size={"2x"} color='#ffffff' />,
    route: "/invoices",
  },
  {
    title: "Reports",
    activeIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#ffffff' />,
    route: "/reports",
  },
  {
    title: "Raise Request",
    activeIcon: <FontAwesomeIcon icon={faFileMedicalAlt} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faFileMedicalAlt} size={"2x"} color='#ffffff' />,
    route: "/raiseRequest",
  },
]

export const rmoMenus: Menu[] = [
  {
    title: "Calendar",
    activeIcon: <FontAwesomeIcon icon={faCalendarDays} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faCalendarDays} size={"2x"} color='#ffffff' />,
    route: "/calendar",
  },
  {
    title: "Consultant",
    activeIcon: <FontAwesomeIcon icon={faUserDoctor} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faUserDoctor} size={"2x"} color='#ffffff' />,
    route: "/consultant",
  },
  {
    title: "Patient Directory",
    activeIcon: <FontAwesomeIcon icon={faUserInjured} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faUserInjured} size={"2x"} color='#ffffff' />,
    route: "/patientList",
  },
  {
    title: "Reports",
    activeIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#ffffff' />,
    route: "/reports",
  },
  {
    title: "Raise Request",
    activeIcon: <FontAwesomeIcon icon={faFileMedicalAlt} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faFileMedicalAlt} size={"2x"} color='#ffffff' />,
    route: "/raiseRequest",
  },
]

export const consultantMenus: Menu[] = [
  {
    title: "Calendar",
    activeIcon: <FontAwesomeIcon icon={faCalendarDays} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faCalendarDays} size={"2x"} color='#ffffff' />,
    route: "/calendar",
  },
  {
    title: "Patient Directory",
    activeIcon: <FontAwesomeIcon icon={faUserInjured} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faUserInjured} size={"2x"} color='#ffffff' />,
    route: "/patientList",
  },
  {
    title: "Reports",
    activeIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#ffffff' />,
    route: "/reports",
  },
  {
    title: "Raise Request",
    activeIcon: <FontAwesomeIcon icon={faFileMedicalAlt} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faFileMedicalAlt} size={"2x"} color='#ffffff' />,
    route: "/raiseRequest",
  },
]

export const homeCareMenus: Menu[] = [
  {
    title: "Calendar",
    activeIcon: <FontAwesomeIcon icon={faCalendarDays} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faCalendarDays} size={"2x"} color='#ffffff' />,
    route: "/calendar",
  },
  {
    title: "Patient Directory",
    activeIcon: <FontAwesomeIcon icon={faUserInjured} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faUserInjured} size={"2x"} color='#ffffff' />,
    route: "/patientList",
  },
  {
    title: "Billing",
    activeIcon: <FontAwesomeIcon icon={faFileInvoice} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faFileInvoice} size={"2x"} color='#ffffff' />,
    route: "/invoices",
  },
  {
    title: "Raise Request",
    activeIcon: <FontAwesomeIcon icon={faFileMedicalAlt} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faFileMedicalAlt} size={"2x"} color='#ffffff' />,
    route: "/raiseRequest",
  },
]

export const nurseMenus: Menu[] = [
  {
    title: "Calendar",
    activeIcon: <FontAwesomeIcon icon={faCalendarDays} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faCalendarDays} size={"2x"} color='#ffffff' />,
    route: "/calendar",
  },
  {
    title: "Patient Directory",
    activeIcon: <FontAwesomeIcon icon={faUserInjured} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faUserInjured} size={"2x"} color='#ffffff' />,
    route: "/patientList",
  },
  {
    title: "Emergency",
    activeIcon: <FontAwesomeIcon icon={faBookMedical} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faBookMedical} size={"2x"} color='#ffffff' />,
    route: "/emergency",
  },
  {
    title: "Raise Request",
    activeIcon: <FontAwesomeIcon icon={faFileMedicalAlt} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faFileMedicalAlt} size={"2x"} color='#ffffff' />,
    route: "/raiseRequest",
  },
]

export const adminMenus: Menu[] = [
  {
    title: "Home",
    activeIcon: <FontAwesomeIcon icon={faHouseMedical} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faHouseMedical} size={"2x"} color='#ffffff' />,
    route: "/home",
  },
  {
    title: "reports",
    activeIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#ffffff' />,
    route: "/reports",
  },
]

export const patientMenus: Menu[] = [
  {
    title: "Patient Detail",
    activeIcon: <FontAwesomeIcon icon={faUserInjured} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faUserInjured} size={"2x"} color='#ffffff' />,
    route: "/patientDetail",
  },
  {
    title: "Book Appointment",
    activeIcon: <FontAwesomeIcon icon={faUserDoctor} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faUserDoctor} size={"2x"} color='#ffffff' />,
    route: "/bookAppointment",
  },
  {
    title: "Contact Us",
    activeIcon: <FontAwesomeIcon icon={faAddressBook} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faAddressBook} size={"2x"} color='#ffffff' />,
    route: "/contactUs",
  },
  {
    title: "Emergency",
    activeIcon: <FontAwesomeIcon icon={faBookMedical} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faBookMedical} size={"2x"} color='#ffffff' />,
    route: "/emergency",
  },
  {
    title: "My Documents",
    activeIcon: <FontAwesomeIcon icon={faFolderOpen} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faFolderOpen} size={"2x"} color='#ffffff' />,
    route: "/myDocuments",
  },
]

export const mrdMenus: Menu[] = [
  {
    title: "Ipd List",
    activeIcon: <FontAwesomeIcon icon={faCalendarDays} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faCalendarDays} size={"2x"} color='#ffffff' />,
    route: "/mrd",
  },
  {
    title: "Patient Directory",
    activeIcon: <FontAwesomeIcon icon={faUserInjured} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faUserInjured} size={"2x"} color='#ffffff' />,
    route: "/patientList",
  },
  {
    title: "Reports",
    activeIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#ffffff' />,
    route: "/reports",
  },
]

export const qualityMenus: Menu[] = [
  {
    title: "home",
    activeIcon: <FontAwesomeIcon icon={faUserDoctor} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faUserDoctor} size={"2x"} color='#ffffff' />,
    route: "/qualityIndicator",
  },
  {
    title: "reports",
    activeIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#ffffff' />,
    route: "/reports",
  },
]

export const insuranceMenus: Menu[] = [
  {
    title: "Billing",
    activeIcon: <FontAwesomeIcon icon={faFileInvoice} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faFileInvoice} size={"2x"} color='#ffffff' />,
    route: "/invoices",
  },
  {
    title: "Reports",
    activeIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#ffffff' />,
    route: "/reports",
  },
]

export const accountantMenus: Menu[] = [
  {
    title: "Reports",
    activeIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#ffffff' />,
    route: "/reports",
  },
]

export const ceoMenus: Menu[] = [
  {
    title: "Reports",
    activeIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faClipboard} size={"2x"} color='#ffffff' />,
    route: "/reports",
  },
]

export const operationsMenus: Menu[] = [
  {
    title: "Home",
    activeIcon: <FontAwesomeIcon icon={faUserDoctor} size={"2x"} color='#6B7280' />,
    inactiveIcon: <FontAwesomeIcon icon={faUserDoctor} size={"2x"} color='#ffffff' />,
    route: "/home",
  },
]
